module.exports = __webpack_public_path__ + "img/lawnstarter-logo.689364f1.png";